import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Breadcrumb,
} from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  updateCmsFaqSection,
  getCmsFaqSectionById,
} from "../../../actions/cmsFaqPageAction";
import FullPageLoader from "../../../components/FullPageLoader/FullPageLoader";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Link } from "react-router-dom";

// Schema for yup
const validationSchema = Yup.object().shape({
  heading: Yup.string()
    .min(2, "Heading must have at least 2 characters")
    .max(100, "Heading can't be longer than 100 characters")
    .trim("Spaces are not allowed")
    .required("Heading is required"),
  section_type: Yup.string().trim().required("Section Type field is required"),
});

const EditFaqSection = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loader, setLoader] = useState(false);
  const [cmsFaqSection, setCmsFaqSection] = useState({});

  const onEditorChange = async (event, editor, setFieldValue) => {
    setFieldValue("content", editor.getData());
  };
  const onContentChange = async (event, editor, setFieldValue) => {
    setFieldValue("content_2", editor.getData());
  };

  useEffect(() => {
    const getCmsFaqSectionId = async () => {
      setLoader(true);
      let res = await getCmsFaqSectionById(id);
      if (res.data.content) {
        let data = res.data.content;
        setCmsFaqSection(data);
      }
      setLoader(false);
    };
    getCmsFaqSectionId();
  }, [id]);
  return (
    <>
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 cms-updated-style">
          <Container fluid>
            <Row>
              <Col md="12">
                {/* <Breadcrumb className="care-md-breadcrumb">
                  <Link className="breadcrumb-item" to="/cms/faqs">
                    Faqs
                  </Link>
                  <Breadcrumb.Item active>Edit</Breadcrumb.Item>
                </Breadcrumb> */}
                <h3>Add Content Page</h3>
                <Card className="filter-card card">
                  <Card.Header>
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Edit Faq
                      </Card.Title>
                    </div>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Formik
                          enableReinitialize
                          initialValues={cmsFaqSection}
                          validationSchema={validationSchema}
                          onSubmit={async (
                            values,
                            { setSubmitting, resetForm }
                          ) => {
                            setLoader(true);
                            // When button submits form and form is in the process of submitting, submit button is disabled
                            setSubmitting(true);
                            let res = await updateCmsFaqSection(id, values);
                            if (res.data.success) {
                              navigate("/cms/faqs");
                              toast.success(res.data.message);
                            }
                            setLoader(false);
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            isSubmitting,
                          }) => (
                            <Form onSubmit={handleSubmit}>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicHeading"
                              >
                                <Form.Label>
                                  Heading <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="heading"
                                  placeholder="Enter heading"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.heading}
                                />
                                {touched.heading && errors.heading ? (
                                  <span
                                    className={errors.heading ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.heading}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicContent"
                              >
                                <Form.Label>Content</Form.Label>
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={values.content ? values.content : ""}
                                  content={values.content ? values.content : ""}
                                  onChange={(event, editor) =>
                                    onEditorChange(event, editor, setFieldValue)
                                  }
                                />
                                {touched.content && errors.content ? (
                                  <span
                                    className={errors.content ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.content}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicContent2"
                              >
                                <Form.Label>Content 2</Form.Label>
                                <CKEditor
                                  editor={ClassicEditor}
                                  data={
                                    values.content_2 ? values.content_2 : ""
                                  }
                                  content={
                                    values.content_2 ? values.content_2 : ""
                                  }
                                  onChange={(event, editor) =>
                                    onContentChange(
                                      event,
                                      editor,
                                      setFieldValue
                                    )
                                  }
                                />
                                {touched.content_2 && errors.content_2 ? (
                                  <span
                                    className={errors.content_2 ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.content_2}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicQuestion"
                              >
                                <Form.Label>Question</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="question"
                                  placeholder="Enter question"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.question}
                                />
                                {touched.link && errors.question ? (
                                  <span
                                    className={errors.question ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.question}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicAnswer"
                              >
                                <Form.Label>Answer</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="answer"
                                  placeholder="Enter answer"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.answer}
                                />
                                {touched.link && errors.answer ? (
                                  <span
                                    className={errors.answer ? `` : `d-none`}
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.answer}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicLink"
                              >
                                <Form.Label>Link</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="link"
                                  placeholder="Enter link"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.link}
                                />
                                {touched.link && errors.link ? (
                                  <span className={errors.link ? `` : `d-none`}>
                                    <label className="pl-1 text-danger">
                                      {errors.link}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <Form.Group
                                className="mb-3"
                                controlId="formBasicSectionType"
                              >
                                <Form.Label>
                                  Section Display Order
                                  <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                  type="number"
                                  name="section_type"
                                  min={0}
                                  placeholder="Enter Section Display Order"
                                  onChange={(e) => handleChange(e)}
                                  value={values.section_type}
                                />
                                {touched.section_type && errors.section_type ? (
                                  <span
                                    className={
                                      errors.section_type ? `` : `d-none`
                                    }
                                  >
                                    <label className="pl-1 text-danger">
                                      {errors.section_type}
                                    </label>
                                  </span>
                                ) : null}
                              </Form.Group>
                              <>
                                <Col className="pl-0">
                                  <label className="label-font">Status</label>
                                </Col>
                                <Col
                                  
                                  className="check-inline d-flex mt-3 flex-column pl-0"
                                >
                                  <label className="right-label-radio mr-3 mb-2">
                                    Active
                                    <input
                                      name="status"
                                      className="status"
                                      checked={values.status}
                                      value={values.status}
                                      type="radio"
                                      onChange={(e) =>
                                        setFieldValue("status", true)
                                      }
                                    />
                                    <span className="checkmark"></span>
                                  </label>
                                  <label className="right-label-radio mr-3 mb-2">
                                    Inactive
                                    <input
                                      name="status1"
                                      className="status"
                                      checked={!values.status}
                                      value={!values.status}
                                      type="radio"
                                      onChange={(e) =>
                                        setFieldValue("status", false)
                                      }
                                    />
                                    <span className="checkmark"></span>
                                  </label>
                                </Col>
                              </>
                              <Button className="btn-filled" type="submit">
                                Update
                              </Button>
                            </Form>
                          )}
                        </Formik>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default EditFaqSection;
